import React from 'react'
import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll";
// @ts-ignore
import FormulaFieldOption from "../list/formula-edit-popover/field-option";

type Props = {
    className?: string,

    fieldsOptions      : any[],
    optionSelect            : callback
}

export default function FormulaEdit_AvailableFields(props: Props) {

    // update by vic
    // delim na 2 grouppi - system fields i custom fields
    // these are FIELD1 objects !

    let systemFields : any[] = _.filter(props.fieldsOptions, (fieldOption: any)=>{
        return !fieldOption.field.customField
    })

    systemFields = _.sortBy(systemFields, (fieldOption)=>{
        if (fieldOption.field.fieldId) {
            return fieldOption.field.label
        } else {
            return gd.const.fields.labels[fieldOption.field.type]
        }
    })

    const customFields : any[] = _.filter(props.fieldsOptions, (fieldOption: any)=>{
        return !!fieldOption.field.customField
    })

    return (
        <div className="ui5-form-formula-selector">
            <VScroll>

                <div className="ui5-title-tiny m-l-10 m-b-15">System Fields</div>

                {_.map(systemFields, (fieldOption)=>{
                    return <FormulaFieldOption key={fieldOption.id} data={fieldOption} onClick={props.optionSelect}/>
                })}

                <div className="ui5-title-tiny m-l-10 m-b-15 m-t-15">Custom Fields</div>

                {_.map(customFields, (fieldOption)=>{
                    return <FormulaFieldOption key={fieldOption.id} data={fieldOption} onClick={props.optionSelect}/>
                })}

            </VScroll>
        </div>
    )

}
